import { Link } from 'react-router-dom';
import { activities } from '@/mocks/activities';
import ActivityCard from '@/components/feature/ActivityCard';
import SectionHeading from '@/components/feature/SectionHeading';
import Reveal from '@/components/feature/Reveal';

export default function FeaturedActivities() {
  const featured = [...activities].sort((a, b) => Number(b.hot) - Number(a.hot)).slice(0, 6);

  return (
    <section className="w-full px-4 md:px-8 py-16 md:py-24 bg-background-50">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
        <SectionHeading
          align="left"
          eyebrow="热门推荐"
          tone="primary"
          title="最近大家都在参加的福利活动"
          desc="按人气与奖励力度挑选出的活动，参与门槛不高，新手也能快速拿到第一笔奖励。"
        />
        <Link
          to="/activities"
          className="self-start md:self-auto shrink-0 inline-flex items-center gap-2 px-5 py-3 rounded-full bg-background-100 text-foreground-800 text-sm font-medium whitespace-nowrap hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer"
        >
          查看全部活动
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
        {featured.map((activity, index) => (
          <Reveal key={activity.id} delay={index * 60}>
            <ActivityCard activity={activity} />
          </Reveal>
        ))}
      </div>
    </section>
  );
}